export default __webpack_public_path__ + "static/media/qrTinch.7505d890.jpg";